import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type NotificationRegisterError = 'on_get_token' | 'on_save_user_device';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationStateService {

  private _notificationPermissionSubject = new BehaviorSubject<NotificationPermission | null>(null);
  private _notificationRegisterSubject = new BehaviorSubject<NotificationRegisterError | null>(null);
  private _isLoadingUserDevice = new BehaviorSubject<boolean>(false);
  private _userDeviceCurrentStatus = new BehaviorSubject<boolean | null>(null);
  private _userDeviceChangeStatus = new BehaviorSubject<boolean | null>(null);

  private _isIOS = false;
  private _isStandalone = false;

  setNotificationPermission(permission: NotificationPermission) {
    return this._notificationPermissionSubject.next(permission);
  }

  get notificationPermission$() {
    return this._notificationPermissionSubject.asObservable();
  }

  setNotificationRegisterError(error: NotificationRegisterError) {
    this._notificationRegisterSubject.next(error);
    this._isLoadingUserDevice.next(false);
  }

  get notificationRegisterError$() {
    return this._notificationRegisterSubject.asObservable();
  }

  setIsLoadingUserDevice(isLoading: boolean) {
    this._isLoadingUserDevice.next(isLoading);
  }

  get isLoadingUserDevice$() {
    return this._isLoadingUserDevice.asObservable();
  }

  setUserDeviceCurrentStatus(status: boolean) {
    this._userDeviceCurrentStatus.next(status);
  }

  get userDeviceCurrentStatus$() {
    return this._userDeviceCurrentStatus.asObservable();
  }

  setUserDeviceStatus(newStatus: boolean) {
    this._userDeviceChangeStatus.next(newStatus);
  }

  get userDeviceChangeStatus$() {
    return this._userDeviceChangeStatus.asObservable();
  }

  set isIOS(isIOS: boolean) {
    this._isIOS = isIOS;
  }

  get isIOS() {
    return this._isIOS;
  }

  set isStandalone(isStandalone: boolean) {
    this._isStandalone = isStandalone;
  }

  get isStandalone() {
    return this._isStandalone;
  }
  
}